<template>
  <div>
    <div class="row">
      <div class="col-md-10"></div>
      <div class="col-md-2"></div>
    </div>
    <div class="col-md-12">
      <h4>Cadastrar Gestores</h4>
    </div>
    <div class="col-md-12">
      <div class="row">
        
        <div class="col-md-12" v-if="msgAlterada" >
          <div
            class="card"
            style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;"
            v-if="msg==1"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{msgAlterada}}</div>
              </div>
            </div>
          </div>
          <div
            class="card"
            style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 20px !important;"
            v-if="msg==0"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{msgAlterada}}</div>
              </div>
            </div>
          </div>
          <div
            class="card"
            style="background-color: rgb(191 187 54) !important;color: #fff !important;margin-bottom: 20px !important;"
            v-if="msg==2"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">{{msgAlterada}}</div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-8">
          <div class="form-group">
            <label class="control-label">Nome</label>
            <input
              type="text"
              id="nome"
              name="nome"
              placeholder="Nome"
              maxlength="200"
              class="form-control"
              v-model="user.nome"
              :style="styleNome"
            />
            <label
              class="control-label"
              v-if="styleNome!=''"
              style="color:rgb(243 0 0);font-size: 12px;"
            >*Obrigatorio</label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
          
            <label>Email</label>
            <input
              type="email"
              placeholder="Email"
              maxlength="250"
              v-on:blur="validacaoEmail(user.email)"
              v-model="user.email"
              class="form-control"
              :style="styleEmail"
            />
            <div v-if="emailverify==0">
              <label
                class="control-label"
                v-if="styleEmail!=''"
                style="color:rgb(243 0 0);font-size: 12px;"
              >*Obrigatorio</label>
            </div>
            <label
              class="control-label"
              v-if="emailverify==1"
              style="color:rgb(54 154 104);font-size: 12px;"
            >Email Valido!
            </label>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Senha</label>
            <input
              type="password"
              placeholder="Senha"
              maxlength="250"
              v-on:blur="validacaoSenha(user.senha)"
              v-model="user.senha"
              class="form-control"
              :style="styleSenha"
            />
            <div v-if="senhaverify==0">
              <label
                class="control-label"
                v-if="styleSenha!=''"
                style="color:rgb(243 0 0);font-size: 12px;"
              >*Obrigatorio</label>
            </div>
            <label
              class="control-label"
              v-if="senhaverify==1"
              style="color:rgb(183 179 55);font-size: 12px;"
            >
              * minimo 4 caracteres
              <br />* minimo 1 letra
              <br />* minimo 1 numero
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        
        <div class="col-md-12"></div>
        <div class="col-md-6">
          <label>CPF</label>
          <the-mask
            class="form-control"
            placeholder="CPF"
            v-model="user.cpf"
            :mask="['###.###.###-##']"

          />
        </div>

        <div class="col-md-6">
          <label>Telefone Celular</label>
          <the-mask
            placeholder="Telefone Celular"
            class="form-control"
            :mask="['(##) #####-####']"
            v-model="user.telefone"
          />
        </div>        

        <div class="col-md-6" style='margin-top:15px;'>
          <div class="form-group">
            <label for="sel1">Tipo:</label>
            <select class="form-control" id="tipo" name="tipo" v-model="user.tipo">
              <option v-for="t in tiposUsuario" :key="t.id" :value="t.id" >{{t.nome}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-12"></div>
        <div class="col-md-6" v-if="user.tipo == 3">
            <div class="form-group">
              <label for="sel1">Unidade Organizacional:</label>
              <multiselect 
                  v-model="user.departamento" 
                  tag-placeholder="Adicione uma Unidade"
                  placeholder="Procurar Unidades"
                  label="secretaria"
                  track-by="id"
                  :options="secretarias"
                  :multiple="true" 
                  :taggable="true"
                >
              </multiselect>
            </div>
        </div>
      </div>
      <div class="col-md-12"></div>

      <!--<div class="row" >
        <div class="col-md-12">
           <label>Ativar</label>
           <switch-button v-model="user.status" color="#253DB9" :meuid="0" modulo="usuario" funcao="exibirCadastro"></switch-button>
        </div>
      </div>-->
      <div class="row">
        <div class="text-center" style="margin-left:15px;margin-top:20px;margin-bottom:20px;">
          <button
            type="button"
            class="btn btn-primary btn-fill float-left"
            @click.prevent="cadastrar" 
          >Cadastrar</button>
          <button class="btn btn-danger" @click="retornar()" style="margin-left: 8px;">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
import store from "src/store.js";
import "src/controller/sistema/usuarioController.js";
import SwitchButton from 'src/components/switch.vue';
import Multiselect from 'vue-multiselect';

export default {
  name: "usuario-cadastrar",
  components: {
    VueGoodTable,
    SwitchButton,
    Multiselect
  },
  data() {
    return {
      user: {
        nome: null,
        email: null,
        senha: null,
        tipo: 3,
        departamento: '',
        cpf: null,
        telefone:null,
        grupo:0,
        status:true,
      },
      tiposUsuario:[],
      secretarias: [],
      users: {
        admin: null,
        admin_sistema: null,
        departamento: null,
      },
      msgAlterada: null,
      msg: null,
      msgAlterada_senha: null,
      msg_senha: null,
      styleNome: "",
      styleEmail: "",
      styleSenha: "",
      emailUsado: null,
      emailverify: 0,
      senhaverify: 0,
      verify_email: false,
      verify_senha: false,
      permissoes: null,
    };
  },
  methods: {
    retornar() {
      this.$router.push({ name: "usuario" });
    },
    async capturarHab(id){

      this.departamentoEscolhidos.nome = [];
      let permissao = await this.$suaPermissao(id);
      let stringDep = permissao.data;
      let stringCompleto = stringDep[0].hab_departamentos;
      let arrayDept = stringCompleto.split(",");

      let secretaria = await this.$secretaria();
      this.secretarias = secretaria.data;

      for (let index = 0; index <= this.secretarias.length; index++) {
        for (let i = 0; i < arrayDept.length; i++) {
            //console.log(arrayDept[i]);
          if(this.secretarias[index]["id"] == arrayDept[i]){
            let param = {
                id: arrayDept[i],
                secretaria: this.secretarias[index]['secretaria']
            };
            this.departamentoEscolhidos.nome.push(param);
          }else{
            
          }
        } 
      }
    },
    validacaoEmail(email) {
      let verificar = this.$email(email);
      if (email) {
        if (email.indexOf("@") >= 0) {
          if (email.indexOf(".") >= 0) {
            
            this.msgAlterada = "";
            this.styleEmail = "border: 2px solid rgb(64 185 124);";
            this.emailverify = 1;
            this.verify_email = true;
            return true;
          } else {
            //email.log("Não é um Email valido!")
            this.styleEmail = "border: 2px solid rgb(243 0 0);";
            this.msgAlterada = "Não é um Email valido!";
            this.emailverify = 0;
            this.verify_email = false;
            this.msg = 0;
            return false;
          }
        } else {
          //email.log("Não é um Email valido!")
          this.styleEmail = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "Não é um Email valido!";
          this.emailverify = 0;
          this.verify_email = false;
          this.msg = 0;
          return false;
        }
      } else {
        this.styleEmail = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Email está Vazio!";
        this.emailverify = 0;
        this.verify_email = false;
        this.msg = 0;
        return false;
      }
    },
    validacaoSenha(senha) {
      if (senha) {
        this.styleSenha = "";
        this.msgAlterada = "";
        this.senhaverify = 0;

        if (senha.length <= 3) {
          this.msgAlterada =
            "O campo Senha tem que ter no minimo 4 Caracteres!";
          this.msg = 2;
          this.senhaverify = 1;
          this.verify_senha = false;
          return false;
        } else {
          this.msgAlterada = "";
        }

        if (senha.search(/[a-z]/i) < 0) {
          this.msgAlterada = "O campo Senha deve possuir no minimo uma letra!";
          this.msg = 2;
          this.senhaverify = 1;
          this.verify_senha = false;
          return false;
        } else {
          this.msgAlterada = "";
        }

        if (senha.search(/[0-9]/i) < 0) {
          this.msgAlterada = "O campo Senha deve possuir no minimo um numero!";
          this.msg = 2;
          this.senhaverify = 1;
          this.verify_senha = false;
          return false;
        } else {
          this.msgAlterada = "";
        }


        this.senhaverify = 0;
        this.verify_senha = true;
      } else {
        this.styleSenha = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Senha está Vazio!";
        this.msg = 0;
        this.senhaverify = 0;
        this.verify_senha = false;
        return false;
      }
    },
    async cadastrar() {
      try {
        this.styleNome = "";
        this.styleEmail = "";
        this.styleSenha = "";
      
        if (this.user.nome == null || this.user.nome =='') {
          this.styleNome = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Nome está Vazio!";
          this.msg = 0;
          return false;
        }
        if (this.user.email == null || this.user.email =='') {
          this.styleEmail = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Email está Vazio!";
          this.msg = 0;
          return false;
        }

        this.validacaoSenha(this.user.senha); 

        if (this.user.senha == null || this.user.senha =='') {
          this.styleSenha = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Senha está Vazio!";
          this.msg = 0;
          return false;
        }

        /*if (this.user.grupo == null || this.user.grupo == 0) {
          this.$alert("O campo Grupo é Obrigatorio!");
          return false;
        }*/


        if (this.user.status == true) {
          this.user.status = 1;
        }else{
          this.user.status = 0;
        }
        
        if(this.verify_senha){

          if(this.user.tipo != 3){
            this.user.departamento = '-1';
          }else{

            let departamento_id = '';
            this.user.departamento.forEach(el => {
              departamento_id = departamento_id.concat('-'+el.id);
            });
            
            this.user.departamento = departamento_id;
          }

          let data = await this.$usuarioCadastro(this.user);

          if (data.msg == "Problemas na validacão!") {
            this.msgAlterada = data.msg;
            this.msg = 0;
            return false;
          }
          if (data.msg == "Email já está em uso!") {
            this.msgAlterada = data.msg;
            this.styleEmail = "border: 2px solid rgb(243 0 0);";
            this.emailverify = 0;
            this.msg = 0;
            return false;
          }
          if(data.data == "Cadastrado com Sucesso!"){
            this.msgAlterada= "Cadastrado com Sucesso!"
            this.msg = 1;
            setTimeout( () => this.$router.push({ path: '/sistema/usuario'}), 150); 
          }
          this.user.departamento = '';
        }
        
      } catch (e) {
        console.log(e);
      }
    },
    async buscarSecretarias() {
      try {
        let data = await this.$secretaria();
        data.data.shift();
        this.secretarias = data.data;
      } catch (e) {
        //console.log(e);
      }
    },
    async buscarTipoUsuario() {
      try {
        let data = await this.$listarTiposUsuario();
        if(this.users.departamento == 0 ){
          this.tiposUsuario = data.data;
        }else{
          data.data.forEach(el=> {
              if(el.nome != 'ADM'){
                let tip = {
                  id: el.id,
                  nome: el.nome,
                };
                this.tiposUsuario.push(tip);
              }
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    async buscarPermissoes(tipo) {
      try {
        this.user.grupo = 0;
        //this.user.departamento = 0;
        let data;
        let permissao = [];
        this.permissoes =[];
        if(tipo == 0){
          data = await this.$listarPermissoes();
          this.permissoes = data.data;
        }else{
          data = await this.$listarPermissoes();
          
          data.data.forEach(el=> {
            console.log(tipo);
            if(el.tipoUsuario == tipo){
               permissao.push(el);
            }
          });
          this.permissoes = permissao;
        }


      } catch (e) {
        //console.log(e);
      }
    },
  },
  beforeMount() {
    try {
      this.users.admin = store.admin;
      this.users.departamento = store.departamento;
      this.users.admin_sistema = store.admin_sistema;
      this.user.tipo = 3;

      this.buscarPermissoes(0);
      this.buscarTipoUsuario();
      this.buscarSecretarias();
    } catch (e) {}
  },
};
</script>

